






























import Vue from "vue";
import messages from "@/messages.json";
export default Vue.extend({
  name: "FileGroup",

  model: {
    prop: "modelValue",
    event: "change"
  },

  data: () => ({
    id: ""
  }),

  created(): void {
    this.id = `file-input-${this._uid}`;
  },

  methods: {
    supportsAdvancedUpload(): boolean {
      const div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },

    handleDragDropUpload(files): void {
      if (!this.supportsAdvancedUpload()) {
        window.alert(messages.error["drag_drop_unsupported"]);
        return;
      }

      this.handleFileUpload(files);
    },

    handleFileUpload(files): void {
      if (files.length === 0) return;

      this.$emit("fileUpload", files);
    }
  }
});
